<!-- <p>user-polls-dialog works!</p> -->
<div
  [ngClass]="{
    'mat-dialog-header':
      screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
    'mat-dialog-header-mobile': screenSize == ScreenType.Mobile
  }"
>
  <h1 mat-dialog-title>{{ data.pollTitle }}</h1>
</div>
<div *ngIf="!isResponseSubmitted">
  <mat-dialog-content class="mat-typography">
    <div class="tickets-dialog-options">
      <div class="form-fields-container">
        <mat-radio-group
          aria-labelledby="example-radio-group-label"
          class="example-radio-group"
          [(ngModel)]="choosedResponse"
        >
          <mat-radio-button
            class="example-radio-button"
            *ngFor="let option of options"
            [value]="option"
          >
            {{ option }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close>Close</button>
    <button
      mat-raised-button
      [mat-dialog-close]="[{ response: choosedResponse, poll: pollData }]"
    >
      Submit
    </button>
  </mat-dialog-actions>
</div>

<div *ngIf="isResponseSubmitted" style="text-align: center; width: 100%">
  <h6>{{ "You already submitted the response" }}</h6>
</div>
